import engineList from './engineList'
import lineConfig from './lineConfig'
import asperaAccountConfig from './asperaAccountConfig'
export default {
  namespaced: true,
  modules: {
    engineList,
    lineConfig,
    asperaAccountConfig,
  },
}
